import { PaldockPage, PaldockPageProps } from "components/UI/PaldockPage/PaldockPage.tsx";

export type TenantPageProps = PaldockPageProps;

export const TenantPage = (props: TenantPageProps) => {
    return <PaldockPage {...props} />;
};
